/*
    This file is part of Privateer.

    Privateer is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Privateer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Privateer.  If not, see <http://www.gnu.org/licenses/>.
*/
import { lang } from './lang.js';

lang.da = {
    QuestionY: "j",
    QuestionN: "n",
    Continue: "Tryk på en tast for at fortsætte!",

    // Player related strings
    PlayerRank1_SEAMAN: "skibsfører",
    PlayerRank1_CAPTAIN: "kaptajn",
    PlayerRank1_LEFTENANTCOMMANDER: "kommandørkaptajn",
    PlayerRank1_COMMANDER: "kommandør",
    PlayerRank1_ADMIRAL: "admiral",
    PlayerRank2_CITISEN: "Borger",
    PlayerRank2_BARON: "BARON",
    PlayerRank2_VISCOUNT: "GREV",
    PlayerRank2_COUNT: "KAMMERHERRE",
    PlayerRank2_ROYAL_HEIR: "KRONPRINS",

    // WELCOME screen strings (aligned with KAPER.BAS intro)
    Welcome1: "Kaptajn Kaper i Kattegat",
    Welcome2: "af P.O.Frederiksen",
    Welcome3: "Version 1 Release 4",
    Welcome4: "",
    Welcome5: "",
    Welcome6: "",
    Welcome7: "",
    Welcome8: "Tryk en tast for at fortsætte",
    Welcome9: "E = Engelsk sprog",
    Welcome10: "C = Slet rekord",
    SoundIntro1: "Du kan altid flippe lyden af og på",
    SoundIntro2: "med F2!",
    SoundIntro3: "Hvad vælger du lige nu?:",
    SoundIntro4: "0: Stilhed",
    SoundIntro5: "1: Lydeffekter",
    SoundIntro6: "Nuværende værdi:",
    SoundIntro7: "Angiv ny værdi:",
    PlayerName1: "Sådan ser dit skib ud:",
    PlayerName2: "Hvad er dit navn",
    PlayerName3: "Du kan afbryde spillet ved at trykke på 'escape'!",
    PlayerName4: "Husk: F1=Hjælp, F2=Lyd på/af, Esc=Slut",

    // MAP screen strings
    Map1: "Point: {0} ",
    Map2: " Mål: {0} på {1} træk",
    Map3: "F1:Hjælp",
    Map4: "F2:Lyd",
    Map5: "Esc:Slut",
    Map6: "Træk:  {0}",
    Map7: "Rgsdl: {0}",
    Map8: "Korn: {0}",
    Map9: "Mænd: {0}",
    Map10: "Skyts: {0}",
    Map11: "Rep: {0}",
    CityName1: "Grenå",
    CityName2: "Ebeltoft",
    CityName3: "Mølle",
    CityName4: "Helsingør",
    CityName5: "Hundested",
    CityName6: "Kalundborg",
    CityName7: "København",

    // PROMOTE screen strings
    Promote1: "Tillykke!!!!",
    Promote2: "Du har netop modtaget",
    Promote3: "din udnævnelse med flaskepost.",
    Promote4: "Komtesse Julie venter dig med længsel!",
    Promote5: "Lad os se, om du kan klare det",
    Promote6: "næste mål {0} {1}!",
    Promote7: "Du har klaret det hele.",
    Promote8: "Du får også det halve kongerige.",

    // MIST screen strings
    Mist1: "Udkiggen melder:",
    Mist2: "Ohøj!",
    Mist3: "der er en underlig tågebanke 2 sømil",
    Mist4: "til styrbord.",
    Mist5: "Det ser ud til,",
    Mist6: "at der er noget inde i den.",
    Mist7: "Nå {0} {1},",
    Mist8: "nu må du vælge:",
    Mist9: "Vil du undersøge det (j/n)?",
    MistType11: "Der dukker af disen",
    MistType12: "et væmmeligt skib!",
    MistType21: "Næh!",
    MistType22: "Der var alligevel ikke noget.",
    MistType31: "Du finder en øde ø",
    MistType32: "med {0} sække korn!",
    MistType41: "Du finder en øde ø",
    MistType42: "med {0} juveler!",
    MistType51: "Du finder en øde ø",
    MistType52: "med en skattekiste,",
    MistType53: "der indeholder {0} rigsdaler!",
    MistType61: "Du finder en øde ø",
    MistType62: "hvor der ligger en kanon,",
    MistType63: "som du tager ombord på dit skib!",
    MistType71: "Du finder en øde ø",
    MistType72: "med en flok skibbrudne,",
    MistType73: "som tager hyre på dit skib!",
    MistType81: "Du finder en øde ø",
    MistType82: "med en pestsyg skibbruden!",
    MistType83: "Han smitter din besætning, og",
    MistType84: "en trediedel af dit mandskab dør!",
    MistType85: "Resten er ikke alt for begejstrede",
    MistType86: "for dit lederskab!",

    // ATTACK screen strings
    Attack1: "Udkiggen melder:",
    Attack2: "Ship ohøj!",
    Attack3: "{0} i sigte",
    Attack4: "Nå {0} {1},",
    Attack5: "nu må du vælge:",
    Attack6: "Vil du angribe (a) eller flygte (f)?",
    AttackY: "a",
    AttackN: "f",
    EnemyName1: "Engelsk handelsmand",
    EnemyName2: "Engelsk troppetransport",
    EnemyName3: "Engelsk kanonbåd",
    EnemyName4: "Engelsk galease",
    EnemyName5: "Engelsk brig",
    EnemyName6: "Engelsk skonnert",
    EnemyName7: "Engelsk orlogsmand",
    EnemyName8: "Sørøverskib",
    Attacking1: "Vil du borde hende (b) eller",
    Attacking2: "vil du skyde (s) på hende?",
    AttackTypeB: "b",
    AttackTypeS: "s",
    AttackSurrender1: "De overgiver sig!!",
    AttackSurrender2: "Der er {0} rigsdaler ombord.",
    AttackSurrender3: "Der er {0} overlevende.",
    AttackSurrender4: "Det flyder med lig på dækket.",
    AttackSurrender5: "Der er {0} sække korn ombord.",
    AttackSurrender6: "Dem tager du!",
    AttackSurrender7: "Dette skib behøver et prisemandskab",
    AttackSurrender8: "på {0} mand!",
    AttackSurrender9: "Du har {0} mand.",
    AttackSurrender10: "Vil du sænke det, (s)",
    AttackSurrender11: "eller tage det som prise (p) ?",
    AttackSurrender12: "OK, de er på vej til København.",
    AttackSurrenderP: "p",
    AttackSurrenderS: "s",
    AttackSunk1: "Den sank!!",
    AttackSunk2: "Du smider {0} mand ud til hajerne!",

    // SHOOT screen strings
    Shooting1: "Fjende",
    Shooting2: "Egen",
    Shooting3: "Sigte",
    Shooting4: "Nedslag",
    Shooting5: "F=fyr. 0=afbryd kampen",
    Shooting6: "Afst: {0}",
    Shooting7: "Vind",
    Shooting8: "Skyts",
    Shooting9: "Mand",
    Shooting10: "Rep",
    Shooting11: "Tryk på en tast.",
    ShootTypeF: "f",
    ShootTypeW: "0",

    // BOARD screen strings
    Boarding1: "Kampen raser ombord på",
    Boarding2: "{0} !",
    Boarding3: "Fjenden har  {0}  faldne,",
    Boarding4: "men han har  {0}  igen.",
    Boarding5: "Du har mistet  {0}  af dine tapre mænd.",
    Boarding6: "Vil du kæmpe videre (k)",
    Boarding7: "eller vende tilbage til dit skib (t)?",
    BoardingEnemyName1: "den engelske",
    BoardingEnemyName2: "sørøverskibet",
    BoardTypeF: "k",
    BoardTypeW: "t",

    // HARBOR screen strings
    Harbor1: "Du er på vej ind i havnen i {0}.",
    Harbor2: "Styr uden om de andre skibe på reden",
    Harbor3: "ind i havneindløbet.",
    Harbor4: "Brug piletasterne for at flytte",
    Harbor5: "til venstre og højre.",
    Harbor6: "Hvis du støder ind i et",
    Harbor7: "af de andre skibe vil dit skib",
    Harbor8: "blive beskadiget, men hvis du",
    Harbor9: "rammer ved siden af havneindløbet,",
    Harbor10: "så overlever du det ikke!",
    Harbor11: "Pas på!!! Der kan komme vindstød fra",
    Harbor12: "venstre!",
    Harbor13: "højre!",
    Prize1: "Hurra!",
    Prize2: "Her i København venter dine {0}",
    Prize3: "tapre mand på dig.",
    Prize4: "De har {0} rigsdaler",
    Prize5: "i prisepenge til dig!",
    Dead1: "Dit skib gik ned med mand og mus",
    Dead2: "",

    // CITY screen strings
    City1: "Velkommen til {0}",
    City2: "Hvad vil du?   {0}",
    City3: "1:Hyre flere mænd ( {0} rgsd pr. mand)",
    City4: "2:Reparere skibet ( {0} rgsd pr. point)",
    City5: "3:Købe kanoner ( {0} rgsd pr stk)",
    City6: "4:Købe korn ( {0} rgsd pr sæk",
    City7: "5:Sælge noget",
    City8: "6:Stå til søs igen.",
    CityBuy1: "Hvor mange? {0}",
    CityBuy2: "Det har du ikke råd til!",
    CityBuy3: "Det er for mange!",
    CitySell1: "Korn(k), Skyts(s) eller Juveler(j) ?",
    CitySell2: "Hvor mange kanoner vil du sælge? {0}",
    CitySell3: "Hvor mange sække korn vil du sælge? {0}",
    CitySell4: "Hvor mange juveler vil du sælge? {0}",
    CitySell5: "Så mange har du ikke!",
    CitySellG: "k",
    CitySellC: "s",
    CitySellJ: "j",

    // GAME_LOST screen strings
    EndGame1: "",
    EndGame2: "Beklager, dit skib gik ned!",
    EndGame3: "Du fik {0} point og havde {1} rigsdaler!",
    EndGame4: "Du sluttede med {0} mand",
    EndGame5: "og {0} reperationspoint",
    CauseOfDeath_TOO_MANY_MONEY: "Vægten af alle dine penge",
    CauseOfDeath_TOO_MANY_MEN: "Vægten af alle dine folk",
    CauseOfDeath_TOO_MANY_CANNONS: "Vægten af alle dine kanoner",
    CauseOfDeath_TOO_MANY_GRAIN: "Vægten af alt dit korn",
    CauseOfDeath: "fik skibet til at synke!",
    CauseOfDeath_TOO_MANY_MOVES1: "Det er med sorg, vi meddeler, at",
    CauseOfDeath_TOO_MANY_MOVES2: "Komtesse Julie Knokkelfryd",
    CauseOfDeath_TOO_MANY_MOVES3: "idag fejrer sit bryllup med",
    CauseOfDeath_TOO_MANY_MOVES4: "den velbårne Tulleman Gylleborg!",
    CauseOfDeath_TOO_MANY_MOVES5: "Af sorg herover, hopper du i havet!",

    // HIGHSCORE screen strings
    HighScore1: "Du fik  {0}",
    HighScore2: "Tryk på en tast for at starte igen.",
    RecordLabel: "Rek.",
    RecordHolderLabel: "Indehaver",

    // HELP menues
    HelpMain1: "Hvilket emne ønsker du at høre om:",
    HelpMain2: " 1: Generelle forudsætninger",
    HelpMain3: " 2: Navigation",
    HelpMain4: " 3: Havne",
    HelpMain5: " 4: Kamp med kanoner",
    HelpMain6: " 5: Kamp ved at borde",
    HelpMain7: " 6: Besætningens røgt og pleje",
    HelpMain8: " 7: Priser, prisepenge og prisemandskab",
    HelpMain9: " 8: Handel",
    HelpMain10: " 9: Tåge, sygdom og skattejagt",
    HelpMain11: " 0: Programinformation",
    HelpMain13: "    Vælg 0-9",
    HelpMain14: " eller tryk på et bogstav,",
    HelpMain15: " hvis du ikke gider høre mere!",
    HelpMenu1_1_1: "Nu må du tænke dig tilbaget til tiden",
    HelpMenu1_1_2: "lige efter Slaget på Reden.",
    HelpMenu1_1_4: "Engelskmanden har røvet de fleste af",
    HelpMenu1_1_5: "vore skibe; kun en håndfuld småskibe -",
    HelpMenu1_1_6: "deriblandt dit - er tilbage.",
    HelpMenu1_1_8: "De engelske skibe sejler, som de lyster",
    HelpMenu1_1_9: "på vore sunde og bælter.",
    HelpMenu1_1_11: "Kongen har givet dig et KAPERBREV,",
    HelpMenu1_1_12: "som giver dig ret til at kapre alle de",
    HelpMenu1_1_13: "engelske skibe, du støder på.",
    HelpMenu1_1_15: "Du får udbetalt en større sum i",
    HelpMenu1_1_16: "prisepenge for hvert skib, du får",
    HelpMenu1_1_17: "afleveret i Københavns havn.",
    HelpMenu1_1_19: "Der, hvor du har nedkæmpet en fjende,",
    HelpMenu1_1_20: "tør englænderne ikke komme mere!",
    HelpMenu1_1_22: "Det gælder også sørøvere!",
    HelpMenu1_2_1: "Du bliver belønnet med point for",
    HelpMenu1_2_2: "at skade englænderne, og hvis du får",
    HelpMenu1_2_3: "point nok, vil kongen adle dig.",
    HelpMenu1_2_5: "Når du er blevet adelig, kan din drøm",
    HelpMenu1_2_6: "gå i opfyldelse:",
    HelpMenu1_2_7: "Du kan blive gift med din hemmelige",
    HelpMenu1_2_8: "forlovede: Komtesse Julie Knokkelfryd",
    HelpMenu1_2_9: "til Knokkelholm.",
    HelpMenu1_2_11: "Men du skal skynde dig!!",
    HelpMenu1_2_13: "Junker Tullemand til Gylleborg er",
    HelpMenu1_2_14: "lun på komtessen, og dersom du ikke",
    HelpMenu1_2_15: "når at blive adlet hurtigt nok, vil",
    HelpMenu1_2_16: "Baron Knokkelfryd skænke sin datters",
    HelpMenu1_2_17: "hånd til den velbeslåede junker!",
    HelpMenu1_2_19: "Derfor:",
    HelpMenu1_2_20: "Frisk mod og god vind!",
    HelpMenu2_1_1: "Du kan se dig selv på kortet over",
    HelpMenu2_1_2: "havet omkring Danmark. Du er vist som",
    HelpMenu2_1_3: "et lille skib, der gynger på vandet.",
    HelpMenu2_1_5: "Du kan flytte dig i 8 retninger ved at",
    HelpMenu2_1_6: "bruge 1-4 og 6-8 (piltasterne).",
    HelpMenu2_1_8: "Du kan ikke sejle udenfor kortet, og",
    HelpMenu2_1_9: "du kan ikke sejle op på land,",
    HelpMenu2_1_10: "men måske ser det ud, som om du",
    HelpMenu2_1_11: "af og til kunne sejle over landtanger.",
    HelpMenu2_1_13: "Hvis du forsøger, at sejle op på land,",
    HelpMenu2_1_14: "sker der skade på bunden af dit skib.",
    HelpMenu2_1_16: "Hvis du forsøger, at sejle ud af kortet,",
    HelpMenu2_1_17: "bliver du bare forhindret i det.",
    HelpMenu3_1_1: "Der er vist 7 havne på kortet.",
    HelpMenu3_1_3: "Når du sejler ind i et kvadrat, hvor",
    HelpMenu3_1_4: "der er en havn, skal du anløbe havnen.",
    HelpMenu3_1_6: "Du skal styre forbi alle de skibe, der",
    HelpMenu3_1_7: "ligger på reden foran havneindløbet.",
    HelpMenu3_1_9: "Du bruget 4 og 6 til at styre med",
    HelpMenu3_1_11: "Hvis du støder sammen med et af de",
    HelpMenu3_1_12: "andre skibe, sker der større eller",
    HelpMenu3_1_13: "mindre skade på dit skib, men hvis du",
    HelpMenu3_1_14: "ikke rammer havneindløbet,",
    HelpMenu3_1_15: "så synker dit skib,",
    HelpMenu3_1_16: "og spillet et slut!",
    HelpMenu3_1_18: "Pas på de pludselige vindstød, der kan",
    HelpMenu3_1_19: "slå dit skib ud af kurs.",
    HelpMenu4_1_1: "Når du møder en fjende kan du vælge",
    HelpMenu4_1_2: "at kæmpe eller at flygte.",
    HelpMenu4_1_3: "Jo oftere du flygter, des dårligere",
    HelpMenu4_1_4: "bliver mandskabets moral, og des",
    HelpMenu4_1_5: "dårligere vil de kæmpe i fremtiden!",
    HelpMenu4_1_7: "Hvis du vælger at kæmpe med kanoner,",
    HelpMenu4_1_8: "vil du få vist et billede af fjendens",
    HelpMenu4_1_9: "skib, som du skal sigte efter.",
    HelpMenu4_1_11: "Sigtet, der er vist som en kors, kan",
    HelpMenu4_1_12: "flyttes med piltasterne.",
    HelpMenu4_1_14: "Du får lige billedet as se på.",
    HelpMenu4_3_1: "Foroven til venstre, kan du se, hvordan",
    HelpMenu4_3_2: "du rammer i forhold til ham, og hvordan",
    HelpMenu4_3_3: "han rammer i forhold til dig.",
    HelpMenu4_3_5: "Det gælder dog kun i begyndelsen.",
    HelpMenu4_3_6: "Senere må du nøjes med det plask,",
    HelpMenu4_3_7: "du kan se øverst til højre.",
    HelpMenu4_3_9: "Det er der kun et øjeblik, og du kan",
    HelpMenu4_3_10: "slet ikke se det, hvis det er bag ved",
    HelpMenu4_3_11: "hans skib.",
    HelpMenu4_3_13: "Se lige på billedet igen.",
    HelpMenu4_5_1: "Forneden til venstre ser du afstand,",
    HelpMenu4_5_2: "vindretning og vindhastighed, som alle",
    HelpMenu4_5_3: "har betydning for,",
    HelpMenu4_5_4: "hvordan du skal sigte.",
    HelpMenu4_5_6: "Hvis du ikke synes om afstanden, kan du",
    HelpMenu4_5_7: "afbryde kampen (0) og angribe igen,",
    HelpMenu4_5_8: "så vil afstanden have ændret sig.",
    HelpMenu4_5_10: "Du kan også afbryde kampen af andre",
    HelpMenu4_5_11: "grunde, feks. fordi du er ved at tabe,",
    HelpMenu4_5_12: "eller fordi du vil borde fjendens skib.",
    HelpMenu4_5_14: "Se lige på billedet igen.",
    HelpMenu4_7_1: "Skemaet forneden på billedet viser dig",
    HelpMenu4_7_2: "din styrke i forhold til hans.",
    HelpMenu4_7_4: "Jo flere kanoner, du har, des mere",
    HelpMenu4_7_5: "skade sker der på ham, når du rammer.",
    HelpMenu4_7_6: "Og omvendt, selvfølgelig!",
    HelpMenu4_7_8: "Du kan følge udviklingen i skemaet.",
    HelpMenu4_7_10: "Kommer du under 20 reperationspoint,",
    HelpMenu4_7_11: "så synker skibet.",
    HelpMenu4_7_13: "Hvis du har mindre end 10 mand tilbage,",
    HelpMenu4_7_14: "så mister du kontrollen over skibet,",
    HelpMenu4_7_15: "og så synker du også!",
    HelpMenu4_7_17: "Se lige på billedet en sidste gang.",
    HelpMenu4_9_1: " ", // Hack to make empty screen
    HelpMenu5_1_1: "Hvis du vælger at borde fjenden,",
    HelpMenu5_1_2: "vil et antal af hans og dine mænd dø!",
    HelpMenu5_1_4: "Hvor mange det er afhænger bla. af dit",
    HelpMenu5_1_5: "mandskabs moral.",
    HelpMenu5_1_7: "Hvis der ikke er ret mange fjender",
    HelpMenu5_1_8: "igen, vil de overgive sig, ellers må du",
    HelpMenu5_1_9: "fortsætte kampen eller trække dig",
    HelpMenu5_1_10: "tilbage til dit skib, enten for at",
    HelpMenu5_1_11: "flygte eller for at bruge kanonerne.",
    HelpMenu5_1_13: "En af fordelene ved at borde, er, at",
    HelpMenu5_1_14: "skibet aldrig synker - det kan ske, når",
    HelpMenu5_1_15: "man bruger kanoner - så du får altid",
    HelpMenu5_1_16: "lagt din klamme hånd på deres penge.",
    HelpMenu5_1_18: "Når de har overgivet sig, kan du enten",
    HelpMenu5_1_19: "sænke skibet (så slutter de overlevende",
    HelpMenu5_1_20: "englændere sig til dit mandskab) eller",
    HelpMenu5_1_21: "du kan tage skibet som prise.",
    HelpMenu5_1_22: " ", // Hack to make 2 empty lines in a row
    HelpMenu6_1_1: "Dine folk kan blive dræbt af fjenden.",
    HelpMenu6_1_3: "Det kan ske både når i duellerer på",
    HelpMenu6_1_4: "kanoner, og når du border fjenden.",
    HelpMenu6_1_6: "Besætningen spiser en vis mængde korn",
    HelpMenu6_1_7: "pr. træk, og hvis kornet slipper op,",
    HelpMenu6_1_8: "begynder mandskabet at dø af sult.",
    HelpMenu6_1_10: "Så er det på høje tid at få købt noget",
    HelpMenu6_1_11: "mere korn (se punkt 8).",
    HelpMenu6_1_13: "Besætningen kan også dø af sygdom.",
    HelpMenu6_1_14: "Det kan du læse mere om i punkt 9.",
    HelpMenu6_1_16: "Husk at besætningens moral og kampevne",
    HelpMenu6_1_17: "falder hver gang, du flygter eller",
    HelpMenu6_1_18: "opgiver en kamp, men den stiger,",
    HelpMenu6_1_19: "hver gang du vinder.",
    HelpMenu7_1_1: "Når du tager en prise, skal du",
    HelpMenu7_1_2: "aflevere den i København.",
    HelpMenu7_1_3: "Det foregår ved at du sætter et",
    HelpMenu7_1_4: "prisemandskab ombord på skibet, og det",
    HelpMenu7_1_5: "har så til opgave at bringe skib og",
    HelpMenu7_1_6: "fanger velbeholdne til hovedstaden.",
    HelpMenu7_1_8: "Hvor mange mand, der skal til,",
    HelpMenu7_1_9: "afhænger af skibtes størrelse og af,",
    HelpMenu7_1_10: "hvor mange fanger, der er at passe på.",
    HelpMenu7_1_11: "Du vil få at vide, hvor mange, der er.",
    HelpMenu7_1_13: "Det er ikke altid, at prisen når frem;",
    HelpMenu7_1_14: "af og til forsvinder den undervejs til",
    HelpMenu7_1_15: "København, og hverken skib eller",
    HelpMenu7_1_16: "mandskab bliver set igen, men for det",
    HelpMenu7_1_17: "meste går det godt, og næste gange, du",
    HelpMenu7_1_18: "kommer til København, vil dine folk",
    HelpMenu7_1_19: "vente på dig med et pænt beløb",
    HelpMenu7_1_20: "i prisepenge.",
    HelpMenu8_1_1: "I havnebyerne kan du købe og sælge.",
    HelpMenu8_1_3: "Du kan få repareret skibet",
    HelpMenu8_1_4: " - dvs. få flere reperationspoint -",
    HelpMenu8_1_5: "og du kan hyre mere mandskab.",
    HelpMenu8_1_7: "Det du kan købe er korn og kanoner.",
    HelpMenu8_1_8: "Du kan sælge korn, kanoner og juveler.",
    HelpMenu8_1_10: "Priserne er i rigsdaler, og skønt de",
    HelpMenu8_1_11: "svinger fra sted til sted og fra dag",
    HelpMenu8_1_12: "til dag, kan der ikke forhandles om dem.",
    HelpMenu8_1_13: "Du kan vælge at sælge korn for at",
    HelpMenu8_1_14: "købe kanoner, eller omvendt,",
    HelpMenu8_1_15: "men du kan ikke sælge dit mandskab",
    HelpMenu8_1_17: "Juveler er sjældne, og kan ikke købes!",
    HelpMenu8_1_18: "De kan kun findes på hemmelige steder.",
    HelpMenu8_2_1: "Du skal ikke købe for meget,",
    HelpMenu8_2_2: "for dit skib kan ikke bære mere end",
    HelpMenu8_2_3: "150 kanoner og 500 mand.",
    HelpMenu8_2_5: "Penge vejer også en del,",
    HelpMenu8_2_6: "og du skal ikke prøve at sejle",
    HelpMenu8_2_7: "med mere end 30000 rigsdaler.",
    HelpMenu8_2_9: "Det er heller ikke klogt at have",
    HelpMenu8_2_10: "mere end 700 sække korn ombord.",
    HelpMenu9_1_1: "Af og til vil du støde på en mystisk",
    HelpMenu9_1_2: "tågebanke, som du kan undersøge eller",
    HelpMenu9_1_3: "vælge at undgå.",
    HelpMenu9_1_5: "Det, der evt. er i den, kan være godt,",
    HelpMenu9_1_6: "men det kan også være skidt.",
    HelpMenu9_1_8: "Både juveler og byldepest er",
    HelpMenu9_1_9: "inden for mulighedernes rækkevidde.",
    HelpMenu0_1_1: "Dette program må gerne kopieres.",
    HelpMenu0_1_3: "Hvis du kender nogen, der kan have",
    HelpMenu0_1_4: "glæde af det, så lad dem få en kopi.",
    HelpMenu0_1_6: "HUSK, at dette ikke omfatter DOS.",
    HelpMenu0_1_7: "Den kræver stadig licens.",
    HelpMenu0_2_1: "Hvis du har lyst til at betale for",
    HelpMenu0_2_2: "programmet, kan du sende feks. 50 kr.",
    HelpMenu0_2_3: "til:",
    HelpMenu0_2_4: " ", // Hack to make 2 empty lines in a row
    HelpMenu0_2_6: "P.O.Frederiksen",
    HelpMenu0_2_8: " Astrupvej 30",
    HelpMenu0_2_10: "  DK8550 Ryomgård",
    HelpMenu0_2_12: "   Danmark",
    HelpMenu0_2_13: " ", // Hack to make 2 empty lines in a row
    HelpMenu0_2_15: "eller indsætte dem på giro 5202531.",
    HelpMenu0_3_1: "Programmet er skrevet i kompileret BASIC",
    HelpMenu0_3_3: "Source-koden kan fås ved at sende",
    HelpMenu0_3_4: "Navn, adresse og 300 kr. til:",
    HelpMenu0_3_6: "P.O.Frederiksen",
    HelpMenu0_3_8: " Astrupvej 30",
    HelpMenu0_3_10: "  DK8550 Ryomgård",
    HelpMenu0_3_12: "   Danmark",
    HelpMenu0_3_13: " ", // Hack to make 2 empty lines in a row
    HelpMenu0_4_1: "Forudsætninger:",
    HelpMenu0_4_2: " ", // Hack to make 2 empty lines in a row
    HelpMenu0_4_4: "Dette program kræver",
    HelpMenu0_4_6: " en IBM PC med mindst",
    HelpMenu0_4_8: "         1 dobbeltsidigt diskettedrive",
    HelpMenu0_4_10: "         128 k",
    HelpMenu0_4_12: "         Farve/grafik-skærm og",
    HelpMenu0_4_14: "         DOS 2.0 eller senere."
};

export default lang.da;
